import { render, staticRenderFns } from "./HomeRecommends.vue?vue&type=template&id=7be602e4&scoped=true&"
import script from "./HomeRecommends.vue?vue&type=script&lang=js&"
export * from "./HomeRecommends.vue?vue&type=script&lang=js&"
import style0 from "./HomeRecommends.vue?vue&type=style&index=0&id=7be602e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be602e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
